var map = {
	"./3dot.svg": "10bf",
	"./arrow-right.svg": "50c3",
	"./arrowSmall.svg": "b18f",
	"./balsa-leaf.svg": "3715",
	"./balsa.css": "69a7",
	"./balsa.svg": "23a9",
	"./dark-theme.css": "a51b",
	"./file.png": "71db",
	"./file.svg": "46c7",
	"./folder.png": "f27d",
	"./folder.svg": "abfe",
	"./folder1.svg": "0fd5",
	"./folder2.svg": "e9a4",
	"./images/icons/add_col_after.svg": "9aa0",
	"./images/icons/add_col_before.svg": "3eee",
	"./images/icons/add_row_after.svg": "d497",
	"./images/icons/add_row_before.svg": "cfee",
	"./images/icons/annotation.svg": "bdbd",
	"./images/icons/arrow.svg": "5975",
	"./images/icons/back.svg": "af81",
	"./images/icons/backDoubleSign.svg": "94b1",
	"./images/icons/balsa.svg": "a71e",
	"./images/icons/bold.svg": "c9a0",
	"./images/icons/checklist.svg": "8559",
	"./images/icons/code.svg": "b9f9",
	"./images/icons/combine_cells.svg": "fca4",
	"./images/icons/delete_col.svg": "f16a",
	"./images/icons/delete_row.svg": "333c",
	"./images/icons/delete_table.svg": "558f",
	"./images/icons/dots.svg": "0620",
	"./images/icons/folder.svg": "ec3d",
	"./images/icons/github.svg": "8211",
	"./images/icons/hr.svg": "2e8e",
	"./images/icons/image.svg": "4d12",
	"./images/icons/italic.svg": "c9f2",
	"./images/icons/link.svg": "7262",
	"./images/icons/logout.svg": "c5d0",
	"./images/icons/mention.svg": "c081",
	"./images/icons/mobile_menu.svg": "e508",
	"./images/icons/ol.svg": "1b7d",
	"./images/icons/paragraph.svg": "eed1",
	"./images/icons/quote.svg": "0b5e",
	"./images/icons/redo.svg": "f76f",
	"./images/icons/remove.svg": "8010",
	"./images/icons/strike.svg": "e37a",
	"./images/icons/table.svg": "1bc9",
	"./images/icons/ul.svg": "ec4c",
	"./images/icons/underline.svg": "9b4c",
	"./images/icons/undo.svg": "f1b4",
	"./logo.png": "cf05",
	"./newFile.png": "4e9b",
	"./newFile2.png": "bf3e",
	"./sass/color.scss": "5820",
	"./sass/cursors.scss": "bddb",
	"./sass/editor.scss": "c4fa",
	"./sass/element-variables.scss": "88df",
	"./sass/main.scss": "9299",
	"./sass/menubar.scss": "188e",
	"./sass/menububble.scss": "2427",
	"./sass/variables.scss": "7f91",
	"./small.svg": "d376",
	"./spreadsheet.png": "c68a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";